import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  getDuplicateEmailMembersAction,
  getNotificationAction,
  getNotificationSummaryAction,
  ignoreNotificationAction,
} from './actions';
import { addMessage } from '../ToastMessagesManager/actions';
import { getErrorMessage } from '../../utils/error.util';
import {
  getDuplicateEmailMembersApi,
  getNotificationListApi,
  getNotificationsSummaryApi,
  ignoreNotificationApi,
} from '../../api/notification.api';
import messages from '../../components/NotificationList/messages';
import { LOADING_STATES } from '../../constants/loading-state.constant';

function* fetchNotifications({ payload }) {
  const { params, loading } = payload;
  if (loading === 1) {
    try {
      const data = yield call(getNotificationListApi, params);
      yield put(getNotificationAction(2, params, data));
    } catch (error) {
      const errMessage = getErrorMessage(error);
      yield put(addMessage({ message: errMessage, variant: 'error' }));
      yield put(getNotificationAction(3));
    }
  }
}

function* fetchDuplicateEmailMembers({ payload }) {
  const { email, loading, notificationId } = payload;
  if (loading === LOADING_STATES.LOADING) {
    try {
      const data = yield call(getDuplicateEmailMembersApi, email);
      yield put(
        getDuplicateEmailMembersAction(
          LOADING_STATES.SUCCESS,
          email,
          notificationId,
          data,
        ),
      );
    } catch (error) {
      const errMessage = getErrorMessage(error);
      yield put(addMessage({ message: errMessage, variant: 'error' }));
      yield put(
        getDuplicateEmailMembersAction(
          LOADING_STATES.ERROR,
          email,
          notificationId,
        ),
      );
    }
  }
}

function* fetchNotificationsByCategory({ payload }) {
  const { loading } = payload;
  if (loading === LOADING_STATES.LOADING) {
    try {
      const data = yield call(getNotificationsSummaryApi);
      yield put(getNotificationSummaryAction(LOADING_STATES.SUCCESS, data));
    } catch (error) {
      yield put(getNotificationSummaryAction(LOADING_STATES.ERROR));
    }
  }
}

function* ignoreNotification({ payload }) {
  const { id, loading } = payload;
  if (loading === LOADING_STATES.LOADING) {
    try {
      yield call(ignoreNotificationApi, id);
      yield put(
        addMessage({ message: messages.ignoreSuccess, variant: 'success' }),
      );
      yield put(ignoreNotificationAction(LOADING_STATES.SUCCESS, id));
    } catch (error) {
      const errMessage = getErrorMessage(error);
      yield put(addMessage({ message: errMessage, variant: 'error' }));
      yield put(ignoreNotificationAction(LOADING_STATES.ERROR, id));
    }
  }
}

// Individual exports for testing
export default function* notificationListSaga() {
  yield takeLatest(getNotificationAction.toString(), fetchNotifications);
  yield takeLatest(
    getNotificationSummaryAction.toString(),
    fetchNotificationsByCategory,
  );
  yield takeEvery(ignoreNotificationAction.toString(), ignoreNotification);
  yield takeLatest(
    getDuplicateEmailMembersAction.toString(),
    fetchDuplicateEmailMembers,
  );
}
